export default class RelatedProjects {
  constructor() {
    this.init();
  }

  init() {
    const limit = 3;
    let counter = limit;
    const items = $('.related-projects .project-item');
    const viewMore = $('.related-projects .view-more');

    if (viewMore.length) {
      items.each((index, element) => {
        if (index >= limit) {
          $(element).hide();
        }
      });

      viewMore.on('click', function() {
        counter = (counter+limit <= items.length) ? counter+limit : items.length;
        $('.related-projects .project-item:lt('+counter+')').fadeIn();
        if(counter == items.length){
          viewMore.hide();
        }
      });
    }
  }
}
